<template>
  <form-group class="money-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <div class="uk-inline">
      <input ref="primaryInput"
             type="number"
             class="uk-input money-input__input"
             step="0.01"
             min="0"
             :class="inputCss"
             :value="internalValue"
             :placeholder="placeholder"
             :disabled="disabled"
             @input="onInput">
      <span class="money-input__currency uk-form-icon uk-form-icon-flip">
        {{currency}}
      </span>
    </div>
  </form-group>
</template>

<script>
import Input from '@/mixins/Input';

export default {
  name: 'money-input',
  mixins: [Input],
  props: {
    value: null,
    placeholder: String,
    currency: {
      type: String,
      default: '€',
    },
  },
};
</script>

<style scoped lang="scss">
.money-input .money-input__input {
  text-align: right;
  &.uk-form-large {
    padding-right: 32px;
  }
}

.uk-form-large + .money-input__currency {
  font-size: 1.25rem;
}

</style>



// WEBPACK FOOTER //
// MoneyInput.vue?0da5e1b8